/**
 * 名簿の取り込みの件数を文にする（取り込む前の確かめ・取り込んだあとの結果）。
 */

/**
 * 取り込む前の確かめの文。**0件の項目は書きません**（J-64）。
 * 「0件を更新します」のように、起きないことまで読ませないため。
 */
export function confirmMessage(created: number, updated: number): string {
  const parts = [
    created > 0 ? `${created}件を新しく登録` : null,
    updated > 0 ? `${updated}件を更新` : null,
  ].filter((part): part is string => part !== null);
  if (parts.length === 0) return 'メンバーの登録内容に変更はありません。';
  return `${parts.join('し、')}します。`;
}

/** 取り込んだあとの結果の文（0件の項目は書かない・J-64）。 */
export function resultMessage(summary: {
  created: number;
  updated: number;
  errors: number;
}): string {
  const parts = [
    summary.created > 0 ? `登録${summary.created}件` : null,
    summary.updated > 0 ? `更新${summary.updated}件` : null,
    summary.errors > 0 ? `取り込めなかった行${summary.errors}件` : null,
  ].filter((part): part is string => part !== null);
  return parts.length === 0 ? '取り込みました。' : `取り込みました（${parts.join('・')}）。`;
}

/** ご自身の電話番号が変わって、管理画面からログアウトしたときの案内（#475 W-15）。 */
export const SELF_PHONE_CHANGED_NOTICE =
  'CSVからメンバーを登録・更新しました。あなたの電話番号が変わったため、ログアウトしました。新しい電話番号でログインし直してください（取り込みの結果は「取り込みの記録」で見られます）。';

/**
 * 取り込む直前の確認の窓に添える、電話番号が変わる方のこと（#475 W-15）。
 * 件数の文だけだと、ご自身の番号が変わってログアウトすることに気づけないため。
 */
export function phoneChangeConfirmText(changes: readonly { isYou: boolean }[]): string {
  const others = changes.filter((change) => !change.isYou).length;
  const includesYou = changes.some((change) => change.isYou);
  const parts = [
    others > 0 ? `${others}名の方は電話番号が変わり、前のスマホのログインが切れます。` : '',
    includesYou
      ? `あなたの電話番号${others > 0 ? 'も' : 'が'}変わるため、取り込むとこの画面からもログアウトします。`
      : '',
  ];
  return parts.join('');
}
